/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import { FC, Fragment } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { customizeValidationSchema } from "../variable/customSchema";
import { getChangePasswordTextFields } from "../variable/textField";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { FormProfileContainer } from "../../../../../shared/components/formProfileContainer";


const ChangePassword: FC = () => {
  const { loading: apiLoading, modifyData } = useMutation(
    "/settings/personal-details"
  );

  const textFields = getChangePasswordTextFields(); // Fetch configuration for input fields

  const initialValues = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const changePasswordForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),
    onSubmit: async (formData: any) => {
      try {
        const { ...requestData } = formData;
        const response = await modifyData("/change-password", "post", {
          ...requestData,
        });

        if (response?.status) {
          console.log("Password changed successfully");
          changePasswordForm.resetForm();
        } else {
          console.error("Error updating password:", response?.data?.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  const titleBar = {
    headerTitle: "Change Password",
    title: "",
    buttonTitle: "Save",
    onClick: () => changePasswordForm.handleSubmit(),
    dirty: changePasswordForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <FormProfileContainer titleBar={titleBar}>
      <Grid container spacing={2}>
        {textFields.map((field: any, index: number) =>
          field?.formField === undefined || field.formField === true ? (
            <Grid item xs={12} sm={6} md={6} key={field.id || index}>
              <InputTextfield
                form={changePasswordForm}
                fieldProps={field}
              />
            </Grid>
          ) : null
        )}
      </Grid>
    </FormProfileContainer>
  );
}  

export default ChangePassword;
